// extracted by mini-css-extract-plugin
module.exports = {"root":"product-tile_root__GvRnE","video":"product-tile_video__0_gxC","aspectRatio":"product-tile_aspectRatio__FW9Bd","badge":"product-tile_badge__7ydYw"};